import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 no-underline mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-building-4-line text-background-50 text-lg"></i>
              </div>
              <span className="text-xl font-bold text-background-50" style={{ fontFamily: 'var(--font-heading)' }}>
                凤楼信息
              </span>
            </Link>
            <p className="text-background-400 text-sm leading-relaxed">
              最全面、最及时的本地信息服务平台，涵盖本地生活、商务资讯、休闲娱乐等多维度内容。
            </p>
          </div>

          <div>
            <h4 className="text-background-50 font-semibold text-sm mb-4 whitespace-nowrap" style={{ fontFamily: 'var(--font-label)' }}>
              信息分类
            </h4>
            <div className="flex flex-col gap-2">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-background-400 hover:text-background-100 text-sm transition-colors duration-200 whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-background-50 font-semibold text-sm mb-4 whitespace-nowrap" style={{ fontFamily: 'var(--font-label)' }}>
              关于我们
            </h4>
            <div className="flex flex-col gap-2">
              <Link
                to="/about"
                className="text-background-400 hover:text-background-100 text-sm transition-colors duration-200 whitespace-nowrap"
              >
                品牌介绍
              </Link>
              <Link
                to="/about"
                className="text-background-400 hover:text-background-100 text-sm transition-colors duration-200 whitespace-nowrap"
              >
                用户口碑
              </Link>
              <Link
                to="/about"
                className="text-background-400 hover:text-background-100 text-sm transition-colors duration-200 whitespace-nowrap"
              >
                联系我们
              </Link>
              <Link
                to="/"
                className="text-background-400 hover:text-background-100 text-sm transition-colors duration-200 whitespace-nowrap"
              >
                隐私政策
              </Link>
            </div>
          </div>

          <div>
            <h4 className="text-background-50 font-semibold text-sm mb-4 whitespace-nowrap" style={{ fontFamily: 'var(--font-label)' }}>
              联系方式
            </h4>
            <div className="flex flex-col gap-2 text-background-400 text-sm">
              <span className="whitespace-nowrap flex items-center gap-2">
                <i className="ri-mail-line"></i> contact@fenglou-info.com
              </span>
              <span className="whitespace-nowrap flex items-center gap-2">
                <i className="ri-phone-line"></i> 400-888-9999
              </span>
              <span className="whitespace-nowrap flex items-center gap-2">
                <i className="ri-map-pin-line"></i> 凤楼区信息大道168号
              </span>
            </div>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-background-500 text-xs">
            &copy; 2026 凤楼信息 FenglouInfo. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-background-500 hover:text-background-200 transition-colors text-lg" aria-label="微信">
              <i className="ri-wechat-line"></i>
            </a>
            <a href="#" className="text-background-500 hover:text-background-200 transition-colors text-lg" aria-label="微博">
              <i className="ri-weibo-line"></i>
            </a>
            <a href="#" className="text-background-500 hover:text-background-200 transition-colors text-lg" aria-label="抖音">
              <i className="ri-tiktok-line"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}